import ChallengeTypeInput, { ChallengeTypeInputType } from './ChallengeTypeInput.container';

export type ChallengeTypeInputProps = ChallengeTypeInputType;

export default ChallengeTypeInput;
